import SplitBox from './SplitBox';
import * as SC from './style';

interface ISplitInfo {
  data: {
    headline: string;
    content: string;
  }[];
}

const SplitInfo = ({ data }: ISplitInfo) => {
  return (
    <div>
      <SC.Container>
        <SC.Inner>
          {data?.map((item, index) => (
            <SplitBox
              key={index}
              headline={item.headline}
              content={item.content}
            />
          ))}
        </SC.Inner>
      </SC.Container>
    </div>
  );
};

export default SplitInfo;
